import { doc, getDoc, setDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import {db} from '../utils/firebase'

export const downloadMenu = (menuType) => {
    if (!Array.isArray(menuType) || menuType.length === 0) {
      return -1;
    }
  
    const formattedMenu = menuType
    //  console.log("dfvdvdv", formattedMenu)
    // if (formattedMenu.length === 0) {
    //   alert("No valid menu items found!");
    //   return;
    // }
  
    const reorderedMenu = formattedMenu.map((item) => ({
      "Level 1": item["Level 1"] || "",  
      "Level 2": item["Level 2"] || "" ,
      "Item Name": item["Item Name"] || "",
      "Item Description": item["Item Description"] || "",
      "Price": item["Price"] || "",
      "Veg_NonVeg":  item["Veg_NonVeg"] || item["Veg/NonVeg"] || "",
     
    }));
    
    try {
      // Convert JSON to Excel
      const ws = XLSX.utils.json_to_sheet(reorderedMenu);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Menu Data");
  
      // Save file
      XLSX.writeFile(wb, "menu_data.xlsx");
      return 1;
    } catch (error) {
      console.error("Error generating Excel:", error);
      return 0;
    }
    }

    export const  handleUpload = async (file, id, menuType) => {
     //console.log("ididiid", id,'fillelelel', file)
      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const data = e.target?.result;
          if (data) {
            const workbook = XLSX.read(data, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            let jsonData = XLSX.utils.sheet_to_json(sheet, {
              defval: null,
            });
            //console.log('jsondatatta', jsonData)
            if (jsonData.length > 0) {
              const keys = Object.keys(jsonData[0]);
              keys.forEach((key) => {
                let lastValue = null;
                jsonData.forEach((row) => {
                  if (!row[key]) {
                    row[key] = lastValue;
                  } else {
                    lastValue = row[key];
                  }
                });
              });
            }
  
            const businessRef = doc(db, "menus", id);

              await setDoc(businessRef, { 
                [menuType]: jsonData 
            }, { merge: true });
            } 
           
            toast.success("Menu uploaded successfully!");

        };
        reader.readAsBinaryString(file);
      } catch (err) {
        toast.error("Failed to upload menu. Please try again.");
        console.error(err);
      } 
    };